
import React from 'react';
import { UserRole } from '../types';

interface SidebarProps {
    role: UserRole;
    isOpen: boolean;
    setIsOpen: (val: boolean) => void;
    currentTab: string;
    setCurrentTab: (tab: string) => void;
}

const LOGO_URL = "https://i.ibb.co/NMthQdw/download-Photoroom.png";

const Sidebar: React.FC<SidebarProps> = ({ role, isOpen, setIsOpen, currentTab, setCurrentTab }) => {
    const commonItems = [
        { id: 'profile', icon: 'fa-user-gear', label: 'My Profile' }
    ];

    const menuItems = {
        [UserRole.ADMIN]: [
            { id: 'dashboard', icon: 'fa-gauge', label: 'Dashboard' },
            { id: 'students', icon: 'fa-user-graduate', label: 'Manage Students' },
            { id: 'staff', icon: 'fa-user-tie', label: 'Manage Staff' },
            { id: 'classes', icon: 'fa-school', label: 'Manage Classes' },
            { id: 'subjects', icon: 'fa-chalkboard', label: 'Manage Subjects' },
            { id: 'attendance', icon: 'fa-calendar-check', label: 'Attendance' },
            { id: 'chat', icon: 'fa-comments', label: 'Community Chat' },
            { id: 'leaves', icon: 'fa-envelope-open-text', label: 'Leave Requests' },
            { id: 'notifications', icon: 'fa-bell', label: 'Announcements' },
            { id: 'resources', icon: 'fa-folder-open', label: 'All Resources' },
            ...commonItems
        ],
        [UserRole.STAFF]: [
            { id: 'dashboard', icon: 'fa-gauge', label: 'Dashboard' },
            { id: 'classes', icon: 'fa-school', label: 'My Classes' },
            { id: 'subjects', icon: 'fa-chalkboard', label: 'My Subjects' },
            { id: 'attendance', icon: 'fa-calendar-check', label: 'Attendance' },
            { id: 'chat', icon: 'fa-comments', label: 'Community Chat' },
            { id: 'leaves', icon: 'fa-envelope-open-text', label: 'Leave Requests' },
            { id: 'scores', icon: 'fa-file-invoice', label: 'Exam Scores' },
            { id: 'resources', icon: 'fa-folder-open', label: 'Shared Resources' },
            { id: 'notifications', icon: 'fa-bell', label: 'Announcements' },
            ...commonItems
        ],
        [UserRole.STUDENT]: [
            { id: 'dashboard', icon: 'fa-gauge', label: 'Dashboard' },
            { id: 'classes', icon: 'fa-school', label: 'My Academic Room' },
            { id: 'chat', icon: 'fa-comments', label: 'Class Chat' },
            { id: 'leaves', icon: 'fa-envelope-open-text', label: 'My Leaves' },
            ...commonItems
        ]
    };

    return (
        <>
            {isOpen && <div className="fixed inset-0 bg-black/50 z-40 lg:hidden" onClick={() => setIsOpen(false)} />}
            <aside className={`fixed top-0 left-0 h-full w-[260px] bg-white dark:bg-dark-sidebar shadow-xl z-50 transition-transform duration-300 ${isOpen ? 'translate-x-0' : '-translate-x-full'} lg:translate-x-0`}>
                <div className="p-6 flex items-center gap-3 border-b border-gray-100 dark:border-gray-800">
                    <img src={LOGO_URL} className="w-10 h-10 object-contain" alt="BSD Logo" />
                    <span className="text-xl font-black dark:text-white tracking-tight">BSD Portal</span>
                </div>
                <nav className="mt-6 px-4 space-y-2 h-[calc(100%-120px)] overflow-y-auto no-scrollbar">
                    {menuItems[role]?.map((item) => (
                        <button
                            key={item.id}
                            onClick={() => { setCurrentTab(item.id); if (window.innerWidth < 1024) setIsOpen(false); }}
                            className={`w-full flex items-center gap-4 px-4 py-3 rounded-xl transition-all ${
                                currentTab === item.id 
                                ? 'bg-purple-600 text-white shadow-xl translate-x-1' 
                                : 'text-gray-500 hover:bg-gray-50 dark:hover:bg-gray-800 dark:text-gray-400'
                            }`}
                        >
                            <i className={`fas ${item.icon} w-5`}></i>
                            <span className="font-bold text-sm">{item.label}</span>
                        </button>
                    ))}
                </nav>
            </aside>
        </>
    );
};

export default Sidebar;
